type StyleType = "currency" | "decimal" | "percent" | "unit";
const style: StyleType = "currency";

export const currencyOptions = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style,
  notation: "compact" as "compact" | "standard" | "scientific" | "engineering",
};
